<template>
    <div class="container-fluid" style="width:1115px !important">        
        <div class="d-block pt-5 mb-1 pb-2 border-bottom" style="color:black !important">
            <div class="row">
                <div class="col">
                    <div class="d-flex align-items-center mb-3 flex-1">
                        <div class="d-block me-3">
                            <div class="avatar">
                                <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                            </div>
                        </div>
                        <div class="d-block overflow-hidden">
                            <div class="d-block h1 m-0 display-tektur block-ellipsis">{{ dataUsers.fullname }}</div>
                            <div class="d-block">{{ dataUsers.school_name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(item, index) in dataEvaluation" :key="index" style="margin-top:-700px !important">
            <div class="card mb-0" style="color:black !important; background-color:transparent !important">
                <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-center h-100">
                                <div class="d-block me-4">
                                    <div class="d-block mb-1" style="font-size:16px !important">{{ item.university_name }} - {{ item.major_fullname }}</div>
                                    <div class="d-block m-0">Peluang Kompetisi</div>
                                </div>
                                <div class="d-flex align-items-start">
                                    <div class="d-block text-lg display-tektur">
                                        {{item.opportunity}}%
                                    </div>
                                    <div class="d-block pt-3 ps-3">
                                        <div v-if="item.opportunity < 50" class="box-skewed bg-danger">SANGAT RENDAH</div>
                                        <div v-else-if="item.opportunity >= 50 && item.opportunity < 60" class="box-skewed bg-danger">RENDAH</div>
                                        <div v-else-if="item.opportunity >= 60 && item.opportunity < 70" class="box-skewed bg-warning">SEDANG</div>
                                        <div v-else-if="item.opportunity >= 70 && item.opportunity < 80" class="box-skewed bg-success">TINGGI</div>
                                        <div v-else-if="item.opportunity >= 80 && item.opportunity < 90" class="box-skewed bg-success">SANGAT TINGGI</div>
                                        <div v-else-if="item.opportunity >= 90" class="box-skewed bg-primary">EXCELLENT</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center mt-4" style="font-size:13px !important">
                        <div class="col-12">
                            <div class="d-block font-bold mb-3">Skor Bobot Rasionalisasi</div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index Nilai</div>
                                        <div class="text-right">{{item.index_score}}%</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index SNBP</div>
                                        <div class="text-right">{{item.index_snbp}}%</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index SNBT</div>
                                        <div class="text-right">{{item.index_snbt}}%</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index Prestasi</div>
                                        <div class="text-right">{{item.index_achievement}}%</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index Universitas</div>
                                        <div class="text-right">{{item.index_university}}%</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index Jurusan</div>
                                        <div class="text-right">{{item.index_major}}%</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Index Akreditasi</div>
                                        <div class="text-right">{{item.index_accreditation}}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" v-if="item.statistic.id" style="color:black !important; background-color:transparent !important; font-size:13px !important; margin-top:-30px !important" >
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-9">
                            <div class="d-block font-bold mb-3">Data Detail Jurusan</div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Nilai SNBP</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">
                                                {{ item.statistic.pg_rapor }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Kuota SNBP</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">{{ item.statistic.snbp_quota }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Peminat SNBP</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">{{ item.statistic.snbp_applicants }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Persaingan SNBP</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">1:{{ item.statistic.snbp_comparison }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Nilai Rapor Saya</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important" v-for="(itemEvaluation, indexEvaluation) in dataEvaluation" :key="indexEvaluation" >{{ itemEvaluation.avg_score_subject }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Nilai SNBT</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">
                                                {{ item.statistic.pg_utbk }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Kuota SNBT</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">{{ item.statistic.snbt_quota }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Peminat SNBT</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">{{ item.statistic.snbt_applicants }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Persaingan SNBT</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important">1:{{ item.statistic.snbt_comparison }}</div>
                                        </div>
                                    </div>
                                    <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                        <div class="block-ellipsis">Nilai Prasyarat Saya</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div class="display-tektur m-0" style="font-size:20px !important" v-for="(itemEvaluation, indexEvaluation) in dataEvaluation" :key="indexEvaluation" >{{ itemEvaluation.avg_score_prerequisite }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" v-if="dataMajorRank.total_data > 0">
                                    <div class="d-block overflow-hidden pb-2 mb-2">
                                        <div class="block-ellipsis">Peringkat Jurusan di Sekolah</div>
                                        <div class="d-flex align-items-center">
                                            <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                            <div v-if="dataMajorRank.my_rank != '-'" class="display-tektur m-0" style="font-size:20px !important">{{ dataMajorRank.my_rank }} dari {{ dataMajorRank.total_data }}</div>
                                            <div v-if="dataMajorRank.my_rank == '-'" class="display-tektur m-0" style="font-size:20px !important">Peringkat belum diketahui</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-3" style="margin-top:-40px !important">
                            <RadarChart :width="310" :height="310" :chart-data="dataChartRecap" :fontColor="'#000'"/>
                            <small>
                                Keterangan:
                                <ul class="mt-3" v-for="(labelItem, labelIndex) in description_labels" :key="labelIndex">
                                    <li>{{ labelItem }}</li>
                                </ul>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="html2pdf__page-break"/>
            <div class="card" v-if="item.statistic.id" style="color:black !important; background-color:transparent !important; ">
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-block font-bold mb-3">Rekap Perbandingan Nilai</div>
                            <table class="table table-th-0 table-sm-td table-sm-th">
                                <thead>
                                    <tr class="small">
                                        <th></th>
                                        <th class="text-center pb-3">Pencapaian</th>
                                        <th class="text-center pb-3">Saran</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in dataScoreComparison" :key="index" :class="item.prerequisite == 1 ? 'highlight-success':''">
                                        <td class="w-100 td-wrap font-bold m-0 text-black">{{ item.subject_name }}</td>
                                        <td class="text-center">
                                            <div class="box-score box-warning">
                                                <span>{{ item.average_score }}</span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="box-score box-pink">
                                                <span>{{ item.suggest_score }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="html2pdf__page-break"/>
            <div class="card pt-4" style="color:black !important; background-color:transparent !important;">
                <div class="card-body">
                    <table class="table table-th-0 table-td-border table-th-border table-sm-td table-sm-th table-th-style-1" width="100%">
                        <thead>
                            <tr class="th-1">
                                <th class="text-black" rowspan="2" style="font-size:12px !important">Tabel Detail Perbandingan</th>
                                <th style="font-size:12px !important" v-for="(item, index) in total_semester" :key="index" class="text-center text-black" colspan="3">
                                    Semester {{ item }}
                                </th>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in total_semester">
                                    <th v-bind:key="index" class="text-center text-black" style="font-size:12px !important">Nilai</th>
                                    <th v-bind:key="index" class="text-center text-black" style="font-size:12px !important">Saran<br>Minimal</th>
                                    <th v-bind:key="index" class="text-center text-black" style="font-size:12px !important">Saran<br>Ideal</th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dataScoreComparison" :key="index">
                                <td class="font-bold text-black" style="font-size:12px !important">{{ item.subject_name }}</td>

                                <template v-for="(itemDetail, indexDetail) in item.list_score">
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.score" class="box-score box-score-sm-2 " :class="itemDetail.class_btn" style="font-size:12px !important">
                                            <span>{{ itemDetail.score}}</span>
                                        </div>
                                        <span v-if="!itemDetail.score">-</span>
                                    </td>
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.min_suggestion" class="box-score box-score-sm-2" style="font-size:12px !important">
                                            <span>{{ itemDetail.min_suggestion }}</span>
                                        </div>
                                        <span v-if="!itemDetail.min_suggestion">-</span>
                                    </td>
                                    <td v-bind:key="indexDetail" class="text-center">
                                        <div v-if="itemDetail.ideal_suggestion" class="box-score box-score-sm-2" style="font-size:12px !important">
                                            <span>{{ itemDetail.ideal_suggestion }}</span>
                                        </div>
                                        <span v-if="!itemDetail.ideal_suggestion">-</span>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadarChart from '../../components/chart/RadarPrint.vue'
export default {
  name: 'PrintRationalization',
  components: {
      RadarChart,
  },
  props: {
    dataUsers: {
      type: Array,
      default: () => []
    },
    dataEvaluation: {
      type: Array,
      default: () => []
    },
    dataScoreComparison: {
      type: Array,
      default: () => []
    },
    dataChartRecap: {
      type: Array,
      default: () => []
    },
    dataMajorRank: {
      type: Array,
      default: () => []
    },
    description_labels: {
      type: Array,
      default: () => []
    },
    total_semester: {
      type: Number,
      default: 5
    },
  }
}
</script>
